<template>
  <v-dialog v-model="profileDialog" transition="dialog-bottom-transition" persistent max-width="500"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card tile>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title> Profile </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu offset-y v-if="employee && employeeAccess.timeClock && employeeAccess.timeClock.inOut">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list v-if="employee.status === 'clockedIn'">
            <v-list-item @click.stop.prevent="clockInOutEmployee">
              <v-list-item-title>Clock Out</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list v-else>
            <v-list-item @click.stop.prevent="clockInOutEmployee">
              <v-list-item-title>Clock In</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-card-text v-if="employee" class="pa-2">
        <div class="text-h4 text-capitalize">{{ employee.name }}</div>

        <div v-if="employee.phoneNumber">
          <span class="caption">
            <a :href="`tel:${employee.phoneNumber}`">{{
              employee.phoneNumber
              }}</a>
          </span>
        </div>
        <v-row align="center">
          <v-col>
            <div class="caption" v-if="employee.TimeClocks.length !== 0">
              <div v-if="employee.TimeClocks[0].status === 'clockedIn'">
                {{ employee.TimeClocks[0].clockInTime | moment("ddd") }} -
                {{
                  employee.TimeClocks[0].clockInTime | moment("M/D/YY h:mm A")
                }}
              </div>
              <div v-else>
                {{ employee.TimeClocks[0].clockOutTime | moment("ddd") }}
                -
                {{
                  employee.TimeClocks[0].clockOutTime | moment("M/D/YY h:mm A")
                }}
              </div>
            </div>
          </v-col>
          <v-col>
            <div class="text-right" v-if="employee.TimeClocks.length === 0">
              Never
            </div>
            <div v-else class="text-right">
              <div class="font-weight-bold green--text text-right" v-if="employee.TimeClocks[0].status === 'clockedIn'">
                <v-chip color="green" text-color="white">
                  IN
                  <v-avatar right class="green darken-4">
                    <v-icon>mdi-location-enter</v-icon>
                  </v-avatar>
                </v-chip>
              </div>
              <div class="font-weight-bold red--text" v-else>
                <v-chip color="red" text-color="white">
                  OUT
                  <v-avatar right class="red darken-4">
                    <v-icon>mdi-location-exit</v-icon></v-avatar>
                </v-chip>
              </div>
            </div>
          </v-col>
        </v-row>
        <DateTimePicker class="mt-2" :range="true" :key="refreshDateTime" :defaultRange="dateTime.defaultRange"
          v-model="dateTime" :initStartDate="dateTime.start" :initEndDate="dateTime.end" @submit="getPay()" />
      </v-card-text>

      <v-card class="pa-1 px-2" flat tile color="deep-orange lighten-4">
        <strong>Payment</strong>
      </v-card>

      <div v-if="loading">
        <template v-for="row of 3">
          <div :key="row">
            <v-row align="center">
              <v-col cols="9">
                <v-skeleton-loader v-if="loading" :loading="loading" type="list-item-two-line"></v-skeleton-loader>
              </v-col>
              <v-col>
                <v-skeleton-loader v-if="loading" :loading="loading" type="button"></v-skeleton-loader>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
        </template>
      </div>
      <!-- <CSPLoader class="mt-5" v-if="loading" :model="true" /> -->

      <div v-else>
        <div v-if="pay.length > 0" class="touch-view-container">
          <swipe-list ref="list" class="card" :items="pay" item-key="id" id="register-cart-list">
            <template v-slot="{ item, index }">
              <v-list-item @click.stop.prevent="viewReceipt(item)">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 text-capitalize"
                    v-if="employeeAccess.report && employeeAccess.report.showPay">
                    {{ item.amount | currency }}
                  </v-list-item-title>
                  <!-- <v-list-item-subtitle v-if="item.phoneNumber">
                      <span class="caption">
                        <a :href="`tel:${item.phoneNumber}`">{{
                          item.phoneNumber
                        }}</a>
                      </span>
                    </v-list-item-subtitle> -->
                  <v-list-item-subtitle class="caption">
                    <strong>Date: </strong>
                    <span>{{ item.enteredAt | moment("LL LT") }}</span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.pickedUpAt" class="caption">
                    <strong>Pickup @</strong>
                    <span>{{ item.pickedUpAt | moment("MM/DD/YYYY") }}</span>
                  </v-list-item-subtitle>
                  <!-- <v-list-item-subtitle v-if="item.phoneNumber">
                    <span class="caption">{{ item.phoneNumber }}</span>
                  </v-list-item-subtitle> -->
                </v-list-item-content>
                <v-list-item-action-text>
                  <div class="font-weight-bold text-right" v-if="item.pickedUpAt">
                    <v-chip color="light-blue lighten-4" text-color="light-blue darken-4">
                      Picked Up

                      <!-- <v-icon small color="#5E687B">fas fa-signature</v-icon> -->
                      <v-avatar right class="light-blue lighten-4">
                        <v-icon small color="#FFF">fas fa-signature</v-icon>
                        <!-- <v-icon>mdi-location-enter</v-icon> -->
                      </v-avatar>
                    </v-chip>
                  </div>
                  <div class="font-weight-bold" v-else>
                    <!-- <v-chip color="blue-grey lighten-4" text-color="blue-grey darken-2">
                    Waiting
                  </v-chip> -->
                    <v-btn v-if="employeeAccess.pay && employeeAccess.pay.pickup" color="primary"
                      @click="payNow(item)">Pay Now</v-btn>
                  </div>
                </v-list-item-action-text>
              </v-list-item>
              <v-divider v-if="index + 1 < pay.length" :key="index"></v-divider>
            </template>

            <template v-slot:right="{ item }" v-if="employeeAccess.pay && employeeAccess.pay.delete">
              <v-btn color="error" class="ma-0 tile" @click.stop.prevent="deleteRow(item)"
                style="height: 100%; min-width: 30px !important">
                <v-icon class="pa-3">mdi-delete</v-icon>
              </v-btn>

              <!-- <v-btn
                color="info"
                class="ma-0 tile"
                @click.stop.prevent="close"
                style="height: 100%; min-width: 30px !important"
              >
              </v-btn> -->
            </template>
            <template v-slot:left="{ item }" v-if="employeeAccess.pay && employeeAccess.pay.markUnPickup">
              <v-btn v-if="item.pickedUpAt" color="warning" class="ma-0 tile" @click.stop.prevent="unPickup(item)"
                style="height: 100%; min-width: 30px !important">
                Un-Pickup
              </v-btn>
            </template>
          </swipe-list>
        </div>
        <div class="text-center" v-else>
          <v-chip label class="my-5">
            <v-icon class="mr-2" size="20">mdi-emoticon-sad-outline</v-icon> No
            payment created yet!
          </v-chip>
        </div>

        <v-dialog v-if="selectedPayRow" v-model="createPayDialog" :fullscreen="$vuetify.breakpoint.xsOnly" persistent
          max-width="550" transition="dialog-bottom-transition">
          <v-card tile>
            <v-toolbar dark color="secondary">
              <v-btn icon dark @click="closeReceive">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Receive Payment</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark :loading="saveBtnLoading" text @click="submit">
                  Save
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-row>
              <v-col cols="12">
                <v-card-text>
                  <div class="text-h4">{{ employee.name }}</div>
                  <div v-if="employee.phoneNumber">
                    <span class="caption">
                      <a :href="`tel:${employee.phoneNumber}`">{{
                        employee.phoneNumber
                        }}</a>
                    </span>
                  </div>
                  <div class="mb-2">
                    <span>Date:</span>
                    <strong>{{
                      selectedPayRow.enteredAt | moment("LL LT")
                      }}</strong>
                  </div>
                  <div class="display-3">
                    {{ selectedPayRow.amount | currency }}
                  </div>
                  <p v-if="selectedPayRow && selectedPayRow.note">
                    {{ selectedPayRow.note }}
                  </p>
                </v-card-text>
              </v-col>
              <v-col cols="12">
                <div style="height: 100%">
                  <v-card-text>
                    <div>Signature</div>
                    <v-card outlined :class="{ errorClass: isError, normal: !isError }">
                      <vueSignature ref="signature" :sigOption="option" :w="'100%'" :h="'250px'"></vueSignature>
                    </v-card>
                  </v-card-text>
                  <div class="text-center mb-5">
                    <v-btn @click="clearSign" color="secondary">Clear</v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>

        <v-dialog v-if="viewReceiptDialog" v-model="viewReceiptDialog" :fullscreen="$vuetify.breakpoint.xsOnly"
          persistent max-width="550" transition="dialog-bottom-transition">
          <v-card tile>
            <v-toolbar dark color="info">
              <v-btn icon dark @click="viewReceiptDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Picked Up Receipt</v-toolbar-title>
            </v-toolbar>
            <v-row>
              <v-col>
                <v-card-text>
                  <div class="text-h4">{{ employee.name }}</div>
                  <div v-if="employee.phoneNumber">
                    <span class="caption">
                      <a :href="`tel:${employee.phoneNumber}`">{{
                        employee.phoneNumber
                        }}</a>
                    </span>
                  </div>
                  <div v-if="employeeAccess.report && employeeAccess.report.showPay"
                    class="display-3 font-weight-light">
                    {{ selectedPayRow.amount | currency }}
                  </div>
                  <p v-if="selectedPayRow && selectedPayRow.note">
                    {{ selectedPayRow.note }}
                  </p>
                  <!-- <div v-if="selectedPayRow && selectedPayRow.pickedUpAt">
                    <span>Picked Up @</span>
                    {{ selectedPayRow.pickedUpAt | moment("LL LT") }}
                  </div>
                  <div v-if="selectedPayRow && selectedPayRow.metadata && selectedPayRow.metadata.hourlyRate">
                    <span>Hourly Rate @</span>
                    {{ selectedPayRow.metadata.hourlyRate | currency }}
                  </div>
                  <div v-if="selectedPayRow && selectedPayRow.metadata && selectedPayRow.metadata.hasOwnProperty('totalSeconds')">
                    <span>Total Hours @</span>
                    {{ selectedPayRow.metadata.totalSeconds/3600 }}
                  </div> -->
                  <v-row v-if="selectedPayRow">
                    <!-- Left Section: Basic Details and Regular Pay -->
                    <v-col cols="6">
                      <!-- Picked Up Time -->
                      <div v-if="selectedPayRow.pickedUpAt">
                        <span>Picked Up @</span>
                        {{ selectedPayRow.pickedUpAt | moment("LL LT") }}
                      </div>

                      <!-- Hourly Rate -->
                      <div v-if="selectedPayRow.metadata && selectedPayRow.metadata.hourlyRate">
                        <span>Hourly Rate:</span>
                        {{ selectedPayRow.metadata.hourlyRate | currency }}
                      </div>

                      <!-- Total Hours Worked -->
                      <div v-if="selectedPayRow.metadata && selectedPayRow.metadata.hasOwnProperty('totalSeconds')">
                        <span>Total Hours Worked: {{ secondsToHms(selectedPayRow.metadata.totalSeconds) }}</span>
                      </div>

                      <!-- Regular Pay -->
                      <div v-if="selectedPayRow.metadata && selectedPayRow.metadata.regularPay >= 0">
                        <h3>Regular Pay:</h3>
                        <strong>{{ selectedPayRow.metadata.regularPay | currency }}</strong>
                      </div>
                    </v-col>

                    <!-- Right Section: Overtime Details (if applicable) -->
                    <v-col cols="6">
                      <div v-if="selectedPayRow.metadata && selectedPayRow.metadata.payOverTime">
                        <v-chip label color="blue" small text-color="white">
                          Overtime Active
                        </v-chip>

                        <!-- Overtime Starts After -->
                        <div>
                          <span>Overtime Starts After:</span>
                          {{ selectedPayRow.metadata.startOverTime }} Hr
                        </div>

                        <!-- Overtime Hours -->
                        <div v-if="selectedPayRow.metadata.overtimeHours > 0">
                          <span>Overtime Hours:</span>
                          {{ secondsToHms(selectedPayRow.metadata.overtimeHours) }}
                        </div>

                        <!-- Overtime Rate -->
                        <div>
                          <span>Overtime Rate:</span>
                          {{ selectedPayRow.metadata.overTimeRate | currency }}
                        </div>

                        <!-- Overtime Pay -->
                        <div v-if="selectedPayRow.metadata.overtimePay > 0">
                          <h3>Overtime Pay: <strong>{{ selectedPayRow.metadata.overtimePay | currency }}</strong></h3>
                          
                        </div>
                      </div>

                      <!-- Total Pay -->
                      <div>
                        <h2>Total Pay: <strong>{{ selectedPayRow.metadata.totalPayWithOvertime | currency }}</strong></h2>
                        
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
              <v-col v-if="employeeAccess.report && employeeAccess.report.showSignature">
                <div style="height: 100%">
                  <v-card-text>
                    <div>Signature</div>
                    <v-card outlined :class="{ errorClass: isError, normal: !isError }">
                      <v-img :lazy-src="selectedPayRow.metadata.signature"
                        :src="selectedPayRow.metadata.signature"></v-img>
                    </v-card>
                  </v-card-text>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
    <ClockInOut v-if="employee" :dialog="dialogClockOut" :selectedRow="employee.TimeClocks[0]"
      @submit="submitWithClockIn" @cancel="dialogClockOut = false" />
  </v-dialog>
</template>

<script>
import payService from "@/modules/Pay/service";
import vueSignature from "vue-signature";
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import ClockInOut from "@/modules/Home/components/ClockInOut.vue";
import DateTimePicker from "@/components/DateTimePicker.vue";
import { mapGetters } from "vuex";

export default {
  props: ["dialog", "employee"],
  data() {
    return {
      dialogClockOut: false,
      viewReceiptDialog: false,
      saveBtnLoading: false,
      createPayDialog: false,
      isError: null,
      profileDialog: false,
      option: {
        minWidth: 8,
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "#FFF",
      },
      refreshDateTime: false,
      dateTime: {
        start: this.$moment()
          .startOf('days')
          .subtract(30, 'days')
          .toISOString(),
        end: this.$moment()
          .endOf('day')
          .toISOString(),
        defaultRange: "since30DaysAgo"
      },
      selectedPayRow: null,
      loading: true,
      pay: null,
    };
  },
  components: {
    vueSignature,
    ClockInOut,
    DateTimePicker,
    SwipeOut,
    SwipeList,
  },
  computed: {
    ...mapGetters("employee", ["employeeAccess"]),
  },
  watch: {
    dialog(val) {
      this.profileDialog = val;
      if (val) {
        // console.log("test in diald", val);

        this.getPay();
      }
    },
  },
  methods: {
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      
        var hDisplay = h > 0 ? h + " h, " : "";
        var mDisplay = m > 0 ? m + " m, " : "";
        var sDisplay = s > 0 ? s + " s " : "";

      return hDisplay + mDisplay + sDisplay;
    },
    isReadOnly(selectedEmployee) {
      console.log('selectedEmployee', selectedEmployee)
      if (selectedEmployee.owner && (this.employee.id != selectedEmployee.id)) return true
      else return false
    },
    clearSign() {
      this.$refs.signature.clear();
    },
    closeReceive() {
      this.clearSign();
      this.createPayDialog = false;
    },
    submitWithClockIn() {
      this.dialogClockOut = false;
      this.close();
    },
    clockInOutEmployee() {
      // this.submitLoading = true
      // // this.selectedRow.clockOutTime = this.$moment();
      // this.selectedRow = e.TimeClocks[0];
      // this.selectedRowIndex = i;
      this.dialogClockOut = true;
    },
    viewReceipt(obj) {
      if (obj.pickedUpAt) {
        this.selectedPayRow = obj;
        this.viewReceiptDialog = true;
      }
    },
    unPickup(obj) {
      console.log("obj", obj);
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You want mark this payment un-pickup",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.loading = true;
            let newMetadata = obj.metadata;
            delete newMetadata.signature;

            return payService
              .update(obj.id, { pickedUpAt: null, metadata: newMetadata })
              .then((response) => {
                console.log("response", response);
                this.$toast.success("Payment Marked Un-pickup", {
                  timeout: 2000,
                });
                // this.createPayDialog = false;
                this.getPay();
                // this.saveBtnLoading = false;
                // this.snackbar.status = true
                // this.snackbar.tet = 'Payment Receive Saved'
              })
              .catch(() => {
                this.saveBtnLoading = false;
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    close() {
      this.pay = [];
      this.dateTime.start = this.$moment().startOf('days').subtract(30, 'days').toISOString();
      this.dateTime.end = this.$moment().endOf('day').toISOString();
      this.dateTime.defaultRange = "since30DaysAgo";
      this.refreshDateTime = !this.refreshDateTime
      this.$emit("close");
    },
    submit() {
      const _this = this;
      if (!_this.$refs.signature.isEmpty()) {
        this.saveBtnLoading = true;
        const base64 = this.$refs.signature.save("image/png");
        let pay = {
          pickedUpAt: new Date(),
        };
        const signature = {
          signature: base64,
        };
        if (this.selectedPayRow.metadata) {
          pay.metadata = {
            ...this.selectedPayRow.metadata,
            ...signature,
          };
        }
        console.log("sending pay", pay);

        return payService
          .update(this.selectedPayRow.id, pay)
          .then((response) => {
            console.log("response", response);
            this.$toast.success("Pay Marked Paid", { timeout: 2000 });
            this.createPayDialog = false;
            this.getPay();
            this.saveBtnLoading = false;
            _this.clearSign();
            // this.snackbar.status = true
            // this.snackbar.tet = 'Payment Receive Saved'
          })
          .catch(() => {
            this.saveBtnLoading = false;
          });
      } else {
        this.isError = true;
        this.$toast.warning("Please signaure in the red box", {
          timeout: 2000,
        });
      }
    },
    payNow(obj) {
      // console.log("pay now obj", obj);
      this.selectedPayRow = obj;
      this.createPayDialog = true;
    },
    deleteRow(obj) {
      // console.log("delete obj", obj);
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You want to delete payment",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.loading = true;
            return payService
              .delete(obj.id)
              .then((response) => {
                console.log("response", response);
                this.$toast.success("Payment is deleted", {
                  timeout: 2000,
                });
                // this.createPayDialog = false;
                this.getPay();
                // this.saveBtnLoading = false;
                // this.snackbar.status = true
                // this.snackbar.tet = 'Payment Receive Saved'
              })
              .catch(() => {
                this.saveBtnLoading = false;
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPay() {
      return payService
        .getAll({
          PaidToEmployeeId: this.employee.id,
          start: this.dateTime.start,
          end: this.dateTime.end
        })
        .then((response) => {
          // console.log("getpay response", response);

          this.pay = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
};
</script>

<style scoped>
.touch-view-container {
  height: calc(100vh - 210px);
  width: 100%;
  overflow: auto;
}

.normal {
  border: solid black 1px !important;
}

.errorClass {
  border: solid red 3px !important;
}
</style>